import React from 'react';
import { Section } from '../ui/Section';
import { Search, EyeOff, BookOpen, Percent, Clock } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <Search className="w-5 h-5 text-gold" data-id="element-185" />,
    title: 'The 2026 National Scan',
    desc: 'How to find invisible inventory in all 50 states before it hits the public portals.'
  }, {
    icon: <EyeOff className="w-5 h-5 text-gold" data-id="element-186" />,
    title: 'The "Blind" Valuation System',
    desc: 'A 10-point checklist to estimate repairs from the sidewalk without ever stepping inside.'
  }, {
    icon: <BookOpen className="w-5 h-5 text-gold" data-id="element-187" />,
    title: 'The Secret Language Cheat Sheet',
    desc: '12 terms that turn legal "noise" into pure profit.'
  }, {
    icon: <Percent className="w-5 h-5 text-gold" data-id="element-188" />,
    title: '3.5% Down Loophole',
    desc: 'How to buy at auction without being a "Cash King."'
  }, {
    icon: <Clock className="w-5 h-5 text-gold" data-id="element-189" />,
    title: 'The 48-Hour Battle Plan',
    desc: "Exactly what to do two days before the hammer falls to ensure you don't overpay."
  }];
  return <Section theme="onyx" className="border-b border-gold-hairline" data-id="element-190">
      <div className="mb-6 flex flex-col items-start" data-id="element-191">
        <div className="flex items-center gap-4 mb-4" data-id="element-192">
          <div className="h-[1px] w-8 bg-gold/30" data-id="element-193"></div>
          <span className="text-gold text-xs font-semibold tracking-[0.2em] uppercase" data-id="element-194">
            What You Get Inside
          </span>
        </div>
      </div>

      <h2 className="text-3xl md:text-5xl font-serif font-medium mb-16 text-bone" data-id="element-195">
        The complete blueprint to bypass the retail market.
      </h2>

      <div className="space-y-4" data-id="element-196">
        {items.map((item, idx) => <div key={idx} className="bg-graphite p-6 md:p-8 border border-gold-hairline flex flex-col md:flex-row gap-6 items-start md:items-center hover:border-gold/40 transition-colors duration-300" data-id="element-197">
            <div className="flex items-center gap-6 shrink-0" data-id="element-198">
              <span className="text-3xl font-serif font-medium italic text-gold/40" data-id="element-199">
                {String(idx + 1).padStart(2, '0')}
              </span>
              <div className="bg-onyx p-3 border border-gold-hairline" data-id="element-200">
                {item.icon}
              </div>
            </div>
            <div data-id="element-201">
              <h3 className="text-xl font-serif font-medium mb-2 text-bone" data-id="element-202">
                {item.title}
              </h3>
              <p className="text-bone-muted text-lg" data-id="element-203">{item.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}